import { VueMaskDirective } from 'v-mask'

export const defineMaskDirective = app => app.directive('mask', function(el, binding) {
  if (!binding.value) {
    return
  }

  VueMaskDirective.bind(el, binding)
})
